import { parseHtml } from '@healthhub/react-ui';
import type { ModalProps } from 'antd';
import { Modal } from 'antd';
import DOMPurify from 'dompurify';
import { memo } from 'react';

import { Button } from '@shared/components';

import { UPCASE_DISCLAIMER_TEXTS } from '@features/Appointment/Questionnaire/constants';

interface HelpInforQuestionnaireModalProps extends ModalProps {
  content: string;
}

const HelperQuestionnaireModal = ({ content, ...rest }: HelpInforQuestionnaireModalProps) => {
  const getBoldedDisclaimerText = () =>
    UPCASE_DISCLAIMER_TEXTS.reduce((replacedText, text) => replacedText.replace(text, `<b>${text}</b>`), content);

  return (
    <Modal
      cancelText={false}
      centered
      className="[&_.ant-modal-footer]:hidden"
      destroyOnHidden
      footer={false}
      {...rest}
    >
      <div className="flex flex-col items-center gap-4 p-2">
        <div className="gbmask">{parseHtml(DOMPurify.sanitize(getBoldedDisclaimerText()))}</div>
        <Button className="json-checked w-full" onClick={rest.onOk}>
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default memo(HelperQuestionnaireModal);
